export enum BankAccountType {
  Client = 0,
  Deposit = 1,
  Current = 2,
}
export enum CompanyAccount {
  Contact = 0,
  Company = 1,
  ContactCompany = 2,
  BillMarkup = 3,
}

export enum RefundTransferFundsFrom {
  Fees = 0,
  BankAccount = 1,
}

export enum TransactionDebitStatus {
  Unpaid = 0,
  Paid = 1,
  Void = 2,
  PartPaid = 4,
}

export enum TransactionCreditStatus {
  Unallocated = 0,
  Allocated = 1,
  Refund = 3,
  PartAllocated = 4,
}

export enum TransactionType {
  Debit = 0,
  Credit = 1,
}

export enum TransferStatus {
  NotRequired = 0,
  Required = 1,
  Transferred = 2,
  Refunded = 3,
}

export enum Product {
  PaymentReceived = 1,
  Deposit = 2,
  RentDue = 3,
  ManagementFees = 4,
  Inventory = 5,
  Maintenance = 6,
  GasCheck = 7,
  ElectricCheck = 8,
  CreditCheck = 9,
  CheckOut = 10,
  BalanceBroughtForward = 11,
  RentReceived = 12,
  BankTransfer = 13,
  PaymentMade = 14,
  AdminFees = 15,
  CheckIn = 16,
  LetOnlyFees = 17,
  RentCollectionFees = 18,
  TaxDeduction = 19,
  MaintenanceCommission = 20,
  BankRecAdjustment = 21,
  BankInterest = 22,
  BankServiceCharge = 23,
  SalesCommission = 24,
  HIPFees = 25,
  DepositDeduction = 26,
  OpeningBalance = 27,
  BillPayment = 28,
  RegistrationFee = 29, //'* For Eire house sales
  BookingDeposit = 30, //'* For Eire house sales
  HoldingDeposit = 31,
  RentBenefit = 32,
  CommercialRentDue = 33,
  CreditNote = 34,
  RentArrearsInterest = 35,
  RentGuaranteePayment = 36,
  AccountBalanceAdjustment = 37,
  BillMarkup = 38,
  HoldingDepositDeductFromRent = 39,
  OverseasTaxRefund = 40,
  AdvertisingCosts = 41,
}

export enum TaxRate {
  Standard = 1,
  Exempt = 2,
  OverseasLandlord = 3,
  TemporaryStandard = 4,
  NewStandard = 5,
}

export enum ProductTransferTo {
  None = 0,
  Landlord = 1,
}

export enum TransactionChargeType {
  None = -1,
  Fee = 0,
  Maintenance = 1,
  Rent = 2,
  Deposit = 3,
  PaymentToLandlord = 4,
  OverseasTax = 5,
  Payment = 6,
}

export enum TransactionCreationMethod {
  System = 0,
  Manual = 1,
  SystemTransfer = 2,
}

export enum RefundType {
  RefundTransaction = 1,
  RefundCustomAmount = 2,
  CreditNote = 3,
}

export enum StatementRunMode {
  AllTransactions = 0,
  UptoToday = 1,
  DateRange = 2,
}

export enum TransactionCheckerMode {
  None = -1,
  Delete = 0,
  Unlink = 1,
  StatementUndo = 2,
  BillDelete = 3,
}
